import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetLayout } from '@/generated/layout';
import { useGetTranslations } from '@/generated/translations';
import { Button } from '../../Button';
import { Icon } from '../../Icon';
import { Logo } from '../../Logo';
import styles from './DrawerHeader.module.scss';

export interface DrawerHeaderProps {
	className?: string;
	title?: string;
	isSubLevel?: boolean;
	handleClose: () => void;
	handleBack?: () => void;
}

export const DrawerHeader: React.FunctionComponent<DrawerHeaderProps> = ({
	className,
	title,
	isSubLevel,
	handleClose,
	handleBack,
}) => {
	const navigate = useNavigate();
	const { segmentationId } = useContext(SegmentationContext);
	const { data: layoutResponse } = useGetLayout(segmentationId);
	const frontPageUrl = layoutResponse?.data.frontPageUrl;
	const { data: translations } = useGetTranslations(segmentationId);

	const goToFrontpage = (): void => {
		// Setting link url this way makes sure mobile menu closes
		// even though user is already on that page
		navigate(frontPageUrl || '/');
		handleClose();
	};

	const renderTitle = (): React.ReactNode => {
		if (isSubLevel) {
			return (
				<Button variant={'ghost'} onClick={handleBack}>
					<Icon name={'chevronDown'} size={'md'} rotate={'90'} />
					<span>{title || translations?.data.shared.back}</span>
				</Button>
			);
		}

		if (!isSubLevel && title) return <p className={styles.headerTitle}>{title}</p>;

		return (
			<Button
				className={styles.logoCta}
				title={translations?.data.shared.siteName}
				hasNoStyles
				onClick={goToFrontpage}
			>
				<Logo name={'ccj'} width={116} height={23} />
			</Button>
		);
	};

	return (
		<header className={classNames(styles.wrapper, className)}>
			{renderTitle()}

			<Button
				variant={'ghost'}
				hasOnlyIcon
				aria-label={translations?.data.shared.close || ''}
				onClick={handleClose}
			>
				<Icon name={'close'} size={'md'} />
			</Button>
		</header>
	);
};
